import styled, { keyframes } from 'styled-components';

const sway1 = keyframes`
  0%, 100% {
    transform: translateX(-50%) rotate(-3deg);
  }
  50% {
    transform: translateX(-50%) rotate(3deg);
  }
`;

const sway2 = keyframes`
  0%, 100% {
    transform: translateX(-50%) rotate(-4deg);
  }
  50% {
    transform: translateX(-50%) rotate(4deg);
  }
`;

const sway3 = keyframes`
  0%, 100% {
    transform: translateX(-50%) rotate(-5deg);
  }
  50% {
    transform: translateX(-50%) rotate(5deg);
  }
`;

const FireContainer = styled.div`
  position: relative;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  width: 127px;
  height: 159px;
`;

const FireElement = styled.div`
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: flex-end;
  justify-content: center;
  z-index: ${props => props.$zIndex || 0};
  transform-origin: center bottom;
  animation: ${props => props.$animation} ${props => props.$duration}s ease-in-out infinite;
`;

const Fire1 = () => {
  return (
    <svg width="46" height="59" viewBox="0 0 46 59" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M21.5092 0C24.955 10.0525 29.7929 9.24826 36.2436 16.8881C42.6943 24.528 45.3766 30.848 45.2953 38.9253C45.3498 45.9691 42.9077 57.1382 36.2436 60.3147C28.6921 63.9143 18.1623 61.6834 15.0018 60.3147C8.71946 57.594 1.12133 50.5861 0.0846634 38.9253C-0.952 27.2644 7.61883 9.24826 21.5092 0Z" fill="#FFFDC8" />
    </svg>
  )
}


const Fire2 = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="89" height="100" viewBox="0 0 89 100" fill="none">
      <path fillRule="evenodd" clipRule="evenodd" d="M48.3945 9.75915e-06C49.036 10.1694 54.2027 19.5976 62.6011 25.9246C71.7246 33.5495 88.8774 50.6844 88.695 68.9575C88.8172 84.8927 79.4319 99.5177 64.4717 106.704C47.5193 114.847 27.3527 109.409 20.2578 106.313C6.15457 100.158 0.815407 87.0911 0.176971 72.3498C-2.53677 41.5879 26.5179 13.0302 48.3945 9.75915e-06Z" fill="#FFE55D" />
    </svg>
  )
}


const Fire3 = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="127" height="159" viewBox="0 0 127 159" fill="none">
      <path fillRule="evenodd" clipRule="evenodd" d="M80.1425 60.8026C80.1425 60.8026 87.5415 18.4102 57.2415 0C56.3302 14.734 48.9919 28.3942 37.0635 37.5612C24.1053 48.6086 -0.256983 73.4346 0.00204916 99.9097C-0.171587 122.998 11.5721 143.41 34.4068 154.599C57.2415 165.788 80.1425 168.1 97.4223 157.622C114.702 147.144 122.616 140.78 125.726 104.825C128.835 68.8691 113.823 46.1285 101.363 35.0747C96.6594 45.2606 89.3559 54.1154 80.1425 60.8026Z" fill="#F85D55" />
    </svg>
  )
}

export const FireLevel = ({ level = 1 }) => {
  return (
    <FireContainer>
      {level >= 3 && (
        <FireElement $zIndex={1} $animation={sway3} $duration={3}>
          <Fire3 />
        </FireElement>
      )}
      {level >= 2 && (
        <FireElement $zIndex={2} $animation={sway2} $duration={2.5}>
          <Fire2 />
        </FireElement>
      )}
      {level >= 1 && (
        <FireElement $zIndex={3} $animation={sway1} $duration={2}>
          <Fire1 />
        </FireElement>
      )}
    </FireContainer>
  )
}
